import { CSSProperties } from 'styled-components';
import BaseHex, { HexCoordinates } from '../base/Hex';

export interface HexComponentProps {
  fill: string;
  className: string;
  style: CSSProperties;
}
export interface HexAttributes {
  props: Partial<HexComponentProps>;
  blocked: boolean; //
  description: string; // description of hex tile for aria; will combile with other dynamoc variables depending on sttate and if rendereing as a board tile or a carousel piece
  // focused: boolean;
  // selected: boolean;
  solved: boolean;
  text: string; // text to show in the hex tile, usually for debugging the hex grid
  shuffleIndex: number;
  // image: string;
  [key: string]: any;
}

// export interface HexProps implements HexCoordinates, extends Partial<HexAttributes> {}

export class Hex extends BaseHex {
  public gridItem?: { row: number; col: number };
  public blocked = false;
  public description = '';
  public text = '';
  public solved = false;
  public shuffleIndex = Math.random();
  public props?: Partial<HexComponentProps>;
  [key: string]: any;
}

// @ts-ignore
Hex.immerable = true;

export default Hex;
